import React, { FC } from "react";

import type { EvaluationType } from "../../state";
import EvaluationButton from "../../atoms/EvaluationButton";

import styles from "./EvaluationToggle.module.scss";

type Props = {
  type: EvaluationType;
  size?: string;
  color: string;
  calling: boolean;
  onEvaluate: (type: EvaluationType) => void;
};

const EvaluationToggle: FC<Props> = ({
  type,
  size = "16",
  color,
  calling,
  onEvaluate,
}) => {
  return (
    <div className={styles.toggle}>
      <EvaluationButton
        type={"good"}
        size={size}
        color={color}
        isEvaluated={"good" === type}
        calling={calling}
        onClick={() => onEvaluate("good")}
      />
      <EvaluationButton
        type={"bad"}
        size={size}
        color={color}
        isEvaluated={"bad" === type}
        calling={calling}
        onClick={() => onEvaluate("bad")}
      />
    </div>
  );
};

export default EvaluationToggle;
